// extracted by mini-css-extract-plugin
module.exports = {"text":"PlaygroundInfoRow_text__l5XrY","label":"PlaygroundInfoRow_label__BMSJb","listText":"PlaygroundInfoRow_listText__q8UZk"};